import { Button, Icons } from '@pankod/refine-antd'

type LogicDeleteProps = {
  click: any,
  disabled?: boolean
}

export const ButtonLogicDelete: React.FC<LogicDeleteProps> = ({ click, disabled = false }) => {
  return (
    <>
      <Button onClick={click} disabled={disabled} size="small" danger>
        <Icons.DeleteOutlined style={{ fontSize: 12 }} />
      </Button>
    </>
  )
}
